import { createRootRoute, createRoute, createRouter, redirect } from '@tanstack/react-router';
import { GalleryShell } from './shell.js';
import { TokensPage } from './pages/tokens.js';
import { AppShellPage } from './pages/app-shell.js';
import { OrgSwitcherPage } from './pages/org-switcher.js';
import { LayoutsPage } from './pages/layouts.js';
import { DataTablePage } from './pages/data-table.js';
import { KpiCardPage } from './pages/kpi-card.js';
import { ChartsPage } from './pages/charts.js';
import { DetailTimelinePage } from './pages/detail-timeline.js';
import { EmptyStatePage } from './pages/empty-state.js';
import { AttentionListPage } from './pages/attention-list.js';
import { DnesekSample } from './pages/samples/dnesek.js';
import { PrehledSample } from './pages/samples/prehled.js';
import { SeznamSample } from './pages/samples/seznam.js';
import { PrazdnyStartSample } from './pages/samples/prazdny-start.js';

const rootRoute = createRootRoute({ component: GalleryShell });

const routes = [
  createRoute({
    getParentRoute: () => rootRoute,
    path: '/',
    beforeLoad: () => {
      throw redirect({ to: '/tokens' });
    },
  }),
  createRoute({ getParentRoute: () => rootRoute, path: '/tokens', component: TokensPage }),
  createRoute({ getParentRoute: () => rootRoute, path: '/components/app-shell', component: AppShellPage }),
  createRoute({ getParentRoute: () => rootRoute, path: '/components/org-switcher', component: OrgSwitcherPage }),
  createRoute({ getParentRoute: () => rootRoute, path: '/components/layouts', component: LayoutsPage }),
  createRoute({ getParentRoute: () => rootRoute, path: '/components/data-table', component: DataTablePage }),
  createRoute({ getParentRoute: () => rootRoute, path: '/components/kpi-card', component: KpiCardPage }),
  createRoute({ getParentRoute: () => rootRoute, path: '/components/charts', component: ChartsPage }),
  createRoute({ getParentRoute: () => rootRoute, path: '/components/detail-timeline', component: DetailTimelinePage }),
  createRoute({ getParentRoute: () => rootRoute, path: '/components/empty-state', component: EmptyStatePage }),
  createRoute({ getParentRoute: () => rootRoute, path: '/components/attention-list', component: AttentionListPage }),
  createRoute({ getParentRoute: () => rootRoute, path: '/samples/dnesek', component: DnesekSample }),
  createRoute({ getParentRoute: () => rootRoute, path: '/samples/prehled', component: PrehledSample }),
  createRoute({ getParentRoute: () => rootRoute, path: '/samples/seznam', component: SeznamSample }),
  createRoute({ getParentRoute: () => rootRoute, path: '/samples/prazdny-start', component: PrazdnyStartSample }),
];

export const router = createRouter({ routeTree: rootRoute.addChildren(routes) });

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
